// extracted by mini-css-extract-plugin
export default {"rev-share-subtitle":"onImcD","revShareSubtitle":"onImcD"};